import React from "react";
import ReactSelect, { components } from "react-select";

interface BasemapsDropdownProps {
  options: any[];
  selectedBasemap: any;
  setSelectedBasemap: (selectedBasemap: any) => void;
}
export default (props: BasemapsDropdownProps) => {
  return (
    <>
      <ReactSelect
        className="w-full"
        value={props.selectedBasemap}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        components={{
          Option: (props) => {
            return (
              <components.Option {...props}>
                <div className="flex items-center">
                  <img src={props.data.thumbnail} className="h-6 w-10 mr-2" />
                  <span>{props.data.title}</span>
                </div>
              </components.Option>
            );
          },
          SingleValue: (props) => {
            return (
              <components.SingleValue {...props}>
                <div className="flex items-center">
                  <img src={props.data.thumbnail} className="h-6 w-10 mr-2" />
                  <span>{props.data.title}</span>
                </div>
              </components.SingleValue>
            );
          },
        }}
        getOptionValue={(option: any) => option.id}
        getOptionLabel={(option: any) => option.title}
        options={props.options}
        onChange={(selectedOption: any) => {
          props.setSelectedBasemap(selectedOption);
        }}
      />
    </>
  );
};
